import {FC} from "react";
import {ITeamTopLink, ITeamTopLinkTranslated} from "../../teams/components/TeamTopLinksBlock";
import styled from "styled-components";
import {LayoutConst} from "../../../../core";
import {Colors} from "@brg/ui";
import {ArrowTopRightIcon} from "../../../modals/ShareModal/icons/ArrowIcons";

const TopLinkWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 858px;

    @media (max-width: 1280px) {
        width: 100%;
    }

        @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 6px;
    }
`

const SplitLine = styled.div`
    border-top: 1px solid #BFBFBF;
    width: 100%;
    background: ${Colors.galBlack27};

    @media (max-width: ${LayoutConst.screen.m}px) {
        background: ${Colors.galBlack10};
    }
`
const Text = styled.div`
    font-size: 17px;
    font-weight: 600;
    word-wrap: break-word;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack47};
    cursor: pointer;
    
    div {
        svg {
            path {
                fill: ${Colors.galBlack47};
            }
        }
    }
    
    &:hover {
        color: #545453;

        div {
            svg {
                path {
                    fill: #545453;
                }
            }
        }
    }
    
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        div {
            svg {
                width: 8px;
                height: 8px;
            }
    }   
    }
`

export const TopLinksList: FC<{topLinks: ITeamTopLinkTranslated[]}> = ({topLinks}) => {

    const getLastWord = (text: string) => {
        const words = text.trim().split(' ');
        return words[words.length - 1];
    }
    const getWithoutLastWord = (text: string) => {
        const words = text.trim().split(' ');
        return words.slice(0, words.length - 1).join(' ') + ' ';
    }

    return <TopLinkWrapper>
        {topLinks.map((topLink, index) => (<>
            <Text onClick={() => window.open(topLink.link, "_blank")} key={index}>
                {getWithoutLastWord(topLink.name)}
                <div style={{
                    display: 'inline',
                    whiteSpace: 'nowrap'
                }}>
                    {getLastWord(topLink.name)}
                    <div style={{
                        display: 'inline',
                        marginLeft: '8px'
                    }}>
                        <ArrowTopRightIcon/>
                    </div>
                </div>
            </Text>
            <SplitLine key={index + '-line'}/>
        </>))}
    </TopLinkWrapper>
}import {FC} from "react";
import {ITeamTopLink, ITeamTopLinkTranslated} from "../../teams/components/TeamTopLinksBlock";
import styled from "styled-components";
import {LayoutConst} from "../../../../core";
import {Colors} from "@brg/ui";
import {ArrowTopRightIcon} from "../../../modals/ShareModal/icons/ArrowIcons";

const TopLinkWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 858px;

    @media (max-width: 1280px) {
        width: 100%;
    }

        @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 6px;
    }
`

const SplitLine = styled.div`
    border-top: 1px solid #BFBFBF;
    width: 100%;
    background: ${Colors.galBlack27};

    @media (max-width: ${LayoutConst.screen.m}px) {
        background: ${Colors.galBlack10};
    }
`
const Text = styled.div`
    font-size: 17px;
    font-weight: 600;
    word-wrap: break-word;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack47};
    cursor: pointer;
    
    div {
        svg {
            path {
                fill: ${Colors.galBlack47};
            }
        }
    }
    
    &:hover {
        color: #545453;

        div {
            svg {
                path {
                    fill: #545453;
                }
            }
        }
    }
    
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        div {
            svg {
                width: 8px;
                height: 8px;
            }
    }   
    }
`

export const TopLinksList: FC<{topLinks: ITeamTopLinkTranslated[]}> = ({topLinks}) => {

    const getLastWord = (text: string) => {
        const words = text.trim().split(' ');
        return words[words.length - 1];
    }
    const getWithoutLastWord = (text: string) => {
        const words = text.trim().split(' ');
        return words.slice(0, words.length - 1).join(' ') + ' ';
    }

    return <TopLinkWrapper>
        {topLinks.map((topLink, index) => (<>
            <Text onClick={() => window.open(topLink.link, "_blank")} key={index}>
                {getWithoutLastWord(topLink.name)}
                <div style={{
                    display: 'inline',
                    whiteSpace: 'nowrap'
                }}>
                    {getLastWord(topLink.name)}
                    <div style={{
                        display: 'inline',
                        marginLeft: '8px'
                    }}>
                        <ArrowTopRightIcon/>
                    </div>
                </div>
            </Text>
            <SplitLine key={index + '-line'}/>
        </>))}
    </TopLinkWrapper>
}